import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { FileTypeCopySource } from './file-type.copysource';
import { AzureBlobDataset } from 'app/model/dataset/azure-blob.dataset';

@Metamodel.model({
    name: 'BlobSource',
    display: [],
    tags: { datasetModel : Metamodel.modelFor(AzureBlobDataset)}
})
export class AzureBlobCopySource extends FileTypeCopySource {
}
